var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanknoteAlternativeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.000546671C3.93257 0.00586224 2.69253 0.0628638 1.77772 0.674122C1.34096 0.965956 0.965956 1.34096 0.674121 1.77772C0 2.78661 0 4.19108 0 7C0 9.80892 0 11.2134 0.674122 12.2223C0.965956 12.659 1.34096 13.034 1.77772 13.3259C2.69253 13.9371 3.93258 13.9941 6.25 13.9995V9.90549C4.95608 9.57246 4 8.39788 4 7C4 5.60212 4.95608 4.42755 6.25 4.09451V0.000546671Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14L12.25 14V0H7.75V14Z",
    fill: "#475467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0.000546671V4.09451C15.0439 4.42755 16 5.60212 16 7C16 8.39788 15.0439 9.57245 13.75 9.90549V13.9995C16.0674 13.9941 17.3075 13.9371 18.2223 13.3259C18.659 13.034 19.034 12.659 19.3259 12.2223C20 11.2134 20 9.80892 20 7C20 4.19107 20 2.78661 19.3259 1.77772C19.034 1.34096 18.659 0.965955 18.2223 0.674121C17.3075 0.0628638 16.0674 0.00586224 13.75 0.000546671Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknoteAlternativeActive);
export default __webpack_public_path__ + "static/media/BanknoteAlternativeActive.8a9bb0c81513a09f13b70ebee18aac11.svg";
export { ForwardRef as ReactComponent };